import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import LoginForm from './components/LoginForm';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { actions as authActions} from '../../../../services/auth/reducer';
import * as moment from 'moment';
import { IStore } from '../../../../redux/IStore';
import { FaSpinner } from 'react-icons/fa';
import { IAuthActions, IAuthState } from '../../../../services/auth/models';

interface ILoginProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  loginFailed: boolean;
  auth: IAuthState;
  channelPhone: string;
}

class Login extends React.Component<ILoginProps> {
  private handleSubmit = (formValues) => {
    const { actions } = this.props;
    const dob = moment(formValues.dob, 'DD/MM/YYYY').format('YYYY-MM-DD');

    return actions.auth.login(formValues.email, formValues.password, dob).then(() => {
      actions.push('/account/summary');
    });
  }

  public render() {
    const { loginFailed, auth, channelPhone } = this.props;

    return (
      <Row className="page-container">
        <Col xs={12}>
          <div className="customer-section-title">
            <h1>Sign In</h1>
            {!auth.hasPasswordBeenReset ? (
              <div className="max-width-wrapper">
                {loginFailed && (
                  <span className="login-failure">
                    Your details do not match our records, please try again.
                    If you have a policy with us, call us on {channelPhone} if the problem continues.
                  </span>
                )}
                <LoginForm onSubmit={this.handleSubmit}/>
              </div>
            ) : (
              <div className="redirect">
                <FaSpinner className="fa-spin spin-icon"/>
                <p>
                  You are now being redirected...
                </p>
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'login',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      return {
        tripType,
        loginFailed: state.auth.loginFailed,
        auth: state.auth,
        channelPhone: state.branding.channel.phone,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(Login);
